<mat-dialog-content *ngIf="!newBuyer" style="padding-bottom: 0px;">
  <form [formGroup]="ticketForm" (ngSubmit)="confirmTicket()">
    <h1 class="display-6">Fish Ticket</h1>

    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Buyer</mat-label>
        <mat-select #select formControlName="buyer" (selectionChange)="addNewBuyer($event)" required>
          <mat-option *ngFor="let buyer of buyers()" [value]="buyer">
            {{buyer}}
          </mat-option>
          <mat-option [value]="">
            Add New
          </mat-option>
        </mat-select>
        <mat-error *ngIf="ticketForm.get('buyer')?.errors?.required">Required</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Ticket #</mat-label>
        <input matInput formControlName="number">
        <mat-error *ngIf="ticketForm.get('number')?.errors?.ticket || ticketForm.get('number')?.errors?.required">{{ticketForm.get('number')?.errors?.ticket.error}}</mat-error>
        <mat-error *ngIf="ticketForm.get('number')?.errors?.duplicate">{{ticketForm.get('number')?.errors?.duplicate.error}}</mat-error>
      </mat-form-field>
    </div>
    <br>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>
          Landing Date
        </mat-label>
        <input matInput [max]="maxDate" [matDatepicker]="picker" formControlName="date" required>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

    </div>
    <br>
  </form>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!newBuyer" align="center" style="justify-content: space-evenly;">
  <button mat-button type="button" class="text-blue-button" (click)="deleteTicket()">Cancel</button>
  <button mat-button type="submit" class="text-button" (click)="confirmTicket()">OK</button>
</mat-dialog-actions>

<h2 mat-dialog-title *ngIf="newBuyer">New Buyer</h2>
<mat-dialog-content *ngIf="newBuyer">
  <mat-form-field>
    <mat-label>New Buyer</mat-label>
    <input matInput [formControl]="newBuyerControl">
    <mat-error *ngIf="newBuyerControl.errors?.required">Required</mat-error>
    <mat-error *ngIf="newBuyerControl.errors?.pattern">Invalid character</mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions *ngIf="newBuyer" align="center" style="justify-content: space-evenly;">
  <button mat-fab
          class="text-blue-button"
          type="button"
          (click)="newBuyer=false">
    Cancel
  </button>
  <button mat-fab
          class="text-button"
          type="button"
          (click)="confirmNewBuyer()">
    OK
  </button>
</mat-dialog-actions>
